<div class="transcript-uploader-container">
  <div
    class="transcript-uploader-content"
    role="region"
    [class.drag-over]="isDragOver"
    [attr.aria-label]="'ITP.dropFilesToUpload' | translate"
    (drop)="onDrop($event)"
    (dragover)="onDragOver($event)"
    (dragenter)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
  >
    @if (isDragOver) {
      <div
        class="upload-message"
        role="status"
        aria-live="polite"
      >
        <i class="fa-solid fa-cloud-arrow-up"></i>
        {{ 'ITP.dropFilesToUpload' | translate }}
      </div>
    }
    <div class="content-layout">
      <div class="table-section">
        <app-transcript-table
          #transcriptTable
          [documents]="visibleTranscripts()"
          [isLoading]="isLoadingTranscripts()"
          [headerLabelKey]="transcriptTypeLabels().headerKey"
          [activeTypeFilter]="activeTypeFilter()"
          [isItpPowerProcessor]="isItpPowerProcessor()"
          (documentSelected)="onTranscriptSelected($event)"
          (documentDeleted)="onTranscriptDeleted($event)"
          (documentsAssigned)="onTranscriptsAssigned($event)"
          (documentsUnassign)="onTranscriptsUnassign($event)"
          (documentsSendToSis)="onTranscriptsSendToSis($event)"
          (filtersCleared)="clearCustomFilters()"
          (typeFilterChanged)="filterByType($event)"
        >
          <div
            class="header-right"
            transcriptUploadButtons
          >
            <p-button
              label="{{ transcriptTypeLabels().selectTranscriptsButtonKey | translate }}"
              severity="secondary"
              variant="outlined"
              size="small"
              icon="fa-solid fa-upload"
              class="dap-upload-itp-btn white-bg-button"
              (click)="showUploadDialog = true"
            ></p-button>
            <p-button
              label="{{ transcriptTypeLabels().scanButtonKey | translate }}"
              severity="secondary"
              variant="outlined"
              size="small"
              icon="fa-solid fa-scanner-image"
              class="dap-scan-itp-btn white-bg-button"
              (click)="startScanProcess()"
            ></p-button>
          </div>
        </app-transcript-table>
      </div>
    </div>
  </div>
</div>
<p-toast
  position="bottom-right"
  key="errorToast"
  class="error-toast"
  role="alert"
>
  <ng-template
    let-message
    pTemplate="message"
  >
    <div class="toast-message-container">
      <div class="icon-container">
        <i class="fa-solid fa-circle-exclamation"></i>
      </div>
      <div class="message-container">
        <span class="message-summary">{{ message.summary | translate }}</span>
        <span>{{ message.detail | translate }}</span>
        @if (message.data) {
          <span>{{ message.data }}</span>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
<app-web-scanning-dialog
  [(visible)]="showScanDialog"
  (filesScanned)="onScannedFiles($event)"
>
</app-web-scanning-dialog>
<app-transcript-upload-dialog
  [titleKey]="transcriptTypeLabels().selectTranscriptsButtonKey"
  [(visible)]="showUploadDialog"
  (upload)="onFilesSelected($event)"
></app-transcript-upload-dialog>
